var indexOf = [].indexOf;

angular.module('gym.calendar').controller('CancelBookingsCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "flash", "MessageService", "EventService", "ReactModal", "booking", "contact", "fromContactProfile", function($scope, $rootScope, $modalInstance, $http, flash, MessageService, EventService, ReactModal, booking, contact, fromContactProfile) {
  var getEventSeriesId, getRecurringBookings, gym;
  gym = $rootScope.gym;
  $scope.initialBooking = booking;
  $scope.selectedBookings = [];
  getEventSeriesId = function(item) {
    return item.event_series_id || item.event_schedule_id;
  };
  $scope.eventSeriesId = getEventSeriesId(booking);
  getRecurringBookings = function() {
    var params;
    if (booking.event_schedule_id) {
      params = {
        event_schedule_id: booking.event_schedule_id,
        contact_id: booking.student_id
      };
      return EventService.getRecurringBookings(params).then(function(recurringBookings) {
        return $scope.recurringBooking = recurringBookings[0];
      });
    }
  };
  getRecurringBookings();
  $scope.loadFutureBookings = function() {
    var params, url;
    $scope.isLoading = true;
    url = `/gyms/${gym.id}/contacts/${contact.id}/bookings/future_bookings`;
    params = {
      count: 1000,
      include_nac_bookings: contact.type === 'non_attending_contact' ? 1 : void 0
    };
    return $http.get(url, {
      params: params
    }).then(function(response) {
      $scope.bookings = _.filter(response.data.collection, function(booking) {
        return !booking.membership_taken_from_contact_id || booking.membership_taken_from_contact_id === booking.student_id;
      });
      if (!$scope.bookings.length || $scope.bookings.length === 1) {
        $scope.noBookings = true;
      }
      $scope.selectedBookings = _.compact($scope.bookings.map(function(booking) {
        if (getEventSeriesId(booking) === $scope.eventSeriesId) {
          return booking.id;
        }
      }));
      return $scope.isLoading = false;
    });
  };
  $scope.bookingDescription = function(booking) {
    var date;
    date = moment(booking.event.start, 'YYYY/MM/DD HH:mm').format('MMM DD, YYYY');
    return [booking.event_name, booking.location_name, date].join(' - ');
  };
  $scope.toggleAll = function() {
    if ($scope.isAllBookingsSelected()) {
      return $scope.selectedBookings = [$scope.initialBooking.id];
    } else {
      return $scope.selectedBookings = $scope.bookings.map(function(booking) {
        return booking.id;
      });
    }
  };
  $scope.toggleBooking = function(id) {
    if ($scope.isBookingSelected(id)) {
      return $scope.selectedBookings = _.without($scope.selectedBookings, id);
    } else {
      return $scope.selectedBookings.push(id);
    }
  };
  $scope.cancelBooking = function() {
    var query, url;
    $scope.isLoading = true;
    query = fromContactProfile ? "?from_contact_profile_page=1" : "";
    url = `/gyms/${gym.id}/calendar/events/${booking.event_id}/bookings/${booking.id}${query}`;
    return $http.delete(url).then(function() {
      return $modalInstance.close();
    }, function() {
      return $scope.isLoading = false;
    });
  };
  $scope.cancelBookings = function() {
    var params, url;
    $scope.isLoading = true;
    url = `/gyms/${gym.id}/contacts/${contact.id}/bulk_delete_bookings/bulk_destroy`;
    params = {
      records_displayed: $scope.bookings.length,
      records_selected: $scope.selectedBookings.length,
      first_event_starts: $scope.bookings[0].start_at,
      last_event_starts: $scope.bookings[$scope.bookings.length - 1].start_at,
      booking_ids: $scope.selectedBookings
    };
    return $http.post(url, params).then(function() {
      var modalInstance;
      modalInstance = ReactModal.open({
        component: 'BulkBookingCancellationRequestedModal',
        props: {
          recurringBooking: $scope.recurringBooking
        }
      });
      return modalInstance.then(function() {
        return $modalInstance.close();
      }, function() {
        return $modalInstance.close();
      });
    }, function() {
      flash.error = 'An error occurred cancelling bookings.';
      return $scope.isLoading = false;
    });
  };
  $scope.isAllBookingsSelected = function() {
    return $scope.selectedBookings.length === $scope.bookings.length;
  };
  $scope.isBookingSelected = function(id) {
    return indexOf.call($scope.selectedBookings, id) >= 0;
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
